import { type FC, useCallback } from 'react'

import { useUnit } from 'effector-react'

import type { MassMessageTablesTypes } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/constants.ts'
import {
  $filterKey,
  setFilterKey,
} from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/massMessages'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  tab: MassMessageTablesTypes
}

export const Tab: FC<Props> = ({ tab }) => {
  const filterKey = useUnit($filterKey)
  const handleClick = useCallback(() => {
    setFilterKey(tab)
  }, [tab])
  const baseClasses = classNames(
    'group flex h-[32px] flex-1 cursor-pointer items-center justify-center gap-[8px] rounded-md px-[12px] transition-all duration-300 ease-out',
    {
      'bg-primary-500 text-neutral-default': tab === filterKey,
      'hover:text-title-500 text-secondary-400 dark:text-secondary-300 hover:bg-primary-500/20 hover:text-primary-500 dark:hover:text-primary-500':
        tab !== filterKey,
    },
  )

  return (
    <button
      className={baseClasses}
      onClick={handleClick}
    >
      <div className="truncate text-sm font-medium">{tab}</div>
    </button>
  )
}
